import { Component, Vue } from 'vue-property-decorator'

@Component
export default class BodyMapMixins extends Vue {
  bodyParts!: BodyPart[] // is assigned via mapState

  get bodyPartInfo() {
    const bodyParts: BodyPart[] = []
    for (const bodyPart of this.bodyParts) {
      if (bodyPart.is_symmetrical) {
        const left = Object.assign({}, bodyPart)
        left.name = "Left " + left.singular_name
        left.key = left.key + "_left"
        const right = Object.assign({}, bodyPart)
        right.name = "Right " + right.singular_name
        right.key = right.key + "_right"
        bodyParts.push(left)
        bodyParts.push(right)
      } else {
        bodyParts.push(bodyPart)
      }
    }
    return bodyParts
  }

  getSymmetricalBodyPartKeys(bodyPartKey) {
    return this.bodyPartInfo.filter(bp => [bodyPartKey + '_left', bodyPartKey + '_right'].includes(bp.key)).map(bp => bp.key)
  }
}